var sessionObj = {};
function assembleQuery(query) {
  return Object.keys(query).reduce(function (prev, next, i) {
    return prev + (i ? '&' : '') + next + '=' + encodeURIComponent(decodeURIComponent(query[next]));
  }, '?');
}
function clearSessionParams() {
  sessionObj = {};
}
function setSessionParams(name, value) {
  sessionObj[name] = value;
}
function clientUrl(url, pathname, query) {
  var path = typeof pathname === 'string' ? pathname : window.location.pathname;
  var context = path.split('/').slice(0, 4).join('/');
  if (url) {
    var queryObj = typeof pathname === 'object' && typeof query === 'undefined' ? pathname : query;
    return context + '/' + removeQueryFromUrl(url).split('/').filter(function (x, i) {
      return x || i;
    }).join('/') + assembleQuery(Object.assign({}, queryObj, sessionObj));
  } else {
    return context;
  }
}
function clientAppUrl(url, pathname, query) {
  return clientUrl("/app".concat(url), pathname, query);
}
function removeQueryFromUrl(url) {
  return url.split('?')[0];
}
function withSession(url, query) {
  return removeQueryFromUrl(url) + assembleQuery(Object.assign({}, query, sessionObj));
}

/** @module clientUrl */
export default {
  /**
   * Remove all session query params that are included in URL building
   * @function
   */
  clearSessionParams: clearSessionParams,
  /**
   * Set session query params to include in URL building
   * @function
   * @param {string} name
   * @param {string} value
   */
  setSessionParams: setSessionParams,
  /**
   * @function
   * @param {string} url
   * @param {string|object} pathname
   * @param {object} query
   * @return {string}
   */
  clientUrl: clientUrl,
  /**
   * @function
   * @param {string} url
   * @param {string} pathname
   * @param {string} query
   * @return {string}
   */
  clientAppUrl: clientAppUrl,
  /**
   * Adds session params to the url, merging with existing params
   * @function
   * @param {string} url
   * @param {object} query
   */
  withSession: withSession
};